class CollectionsMegaMenu extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.collections-mega-menu__trigger');

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        if (this.trigger) this.trigger.focus();
      }
    });

    this.addEventListener('mouseenter', () => this.open());
    this.addEventListener('mouseleave', () => this.close());
    this.addEventListener('focusin', () => this.open());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('collections-mega-menu')) {
  customElements.define('collections-mega-menu', CollectionsMegaMenu);
}
